import { useI18n } from '@change-corgi/core/react/i18n';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';

import { useShareHeadline } from '../../../../hooks/shareHeadline';

type UseMetaTextTags = ModelHookResult<{
	ogTitleContent: string;
	ogDescriptionContent: string;
	ogTwitterImageAlt: string;
}>;

export function useMetaTextOgTags(): UseMetaTextTags {
	const {
		data: {
			petition: { status, signatureState, ask },
		},
	} = usePetitionDetailsPageData();
	const { signatureCount } = signatureState;
	const { translate, translatePlural } = useI18n();
	const shareHeadline = useShareHeadline();

	const ogTitleContent =
		status === 'VICTORY'
			? translatePlural('fe.facebook.share.victory', signatureCount.displayed, {
					signature_count: signatureCount.displayedLocalized,
				})
			: shareHeadline?.title || translate('fe.facebook.share.sign_petition');

	const ogDescriptionContent = status === 'VICTORY' ? ask : shareHeadline?.description || ask;

	return {
		data: {
			ogTitleContent,
			ogDescriptionContent,
			ogTwitterImageAlt: ogTitleContent,
		},
	};
}
